module.exports = __webpack_public_path__ + "41b8d62ac71741897044553b6435f120.png";